// extracted by mini-css-extract-plugin
module.exports = {"btnViewMore":"BtnViewMore_btnViewMore__18SmX","arrowIcon":"BtnViewMore_arrowIcon__fP7-3"};